<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Carrinho</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <button
              class="btn_1 medium pull-right mb-3"
              @click="() => { $bvModal.show('modalCriaCarrinho')}"
              >
              Adicionar
              </button>
          </div>
        </div>

        <v-card>
          <v-card-title>
            Carrinhos
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="carrinho" :search="search" :pagination.sync="pagination">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.user ? props.item.user.id + " - " : null}} {{ props.item.user ? props.item.user.name : null }}</td>
              <td>{{ props.item.user ? props.item.user.email :null }}</td>
              <td>{{ props.item.plan.name }}</td>
              <td>{{ props.item.quantidade }}</td>
              <td>{{ centavos(props.item.valor) }}</td>
              <td class="text-xs-right">
                <button class="btn_1 gray delete wishlist_close" @click="abreModal(props.item)">
                  <i class="fa fa-fw fa-edit"></i> Editar
                </button>
                <button class="btn_1 red delete wishlist_close" @click="removerCarrinho(props.item)">
                  <i class="fa fa-times"></i> remover
                </button>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>


    <!-- Modal Component -->
    <b-modal
      id="modalCarrinho"
      title="Editar Carrinho"
      centered
      ok-title="Salvar"
      ok-only
      @ok="editarCarrinho()"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Plano</label>
            <select
              id="inputUniodonto"
              v-model="planoDaEdicao"
              class="form-control"
            >
              <option
                v-for="(plano,index) in planos"
                :key="index"
                :value="plano.id"
              >{{plano.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Quantidade</label>
            <input
              type="text"
              class="form-control"
              placeholder="Informe o código ANS"
              v-model="quantidadeDaEdicao"
            />
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal cria carrinho -->
    <b-modal
      id="modalCriaCarrinho"
      title="Novo Carrinho"
      centered
      ok-title="Criar carrinho"
      ok-only
      @ok="criaCarrinho()"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Plano</label>
            <select
              id="inputUniodonto"
              v-model="novoPlano.plan_id"
              class="form-control"
            >
            <option value="" selected disabled>Escolha o plano</option>
              <option
                v-for="(plano,index) in planos"
                :key="index"
                :value="plano.id"
              >{{plano.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Quantidade</label>
            <input
              type="text"
              class="form-control"
              placeholder="Quantidade do carrinho"
              v-model="novoPlano.quantidade"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Código usuário</label>
            <input
              type="text"
              class="form-control"
              placeholder="Quantidade do carrinho"
              v-model="novoPlano.user_id"
            />
          </div>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      erroMensagem: "",
      mostraErro: false,
      usuarios: [],
      carrinho: [],
      planos: [],
      novoPlano: {
        user_id: '',
        plan_id: '',
        quantidade: 1
      },
      planoDaEdicao: 0,
      quantidadeDaEdicao: 0,
      idCarrinhoEdicao: 0,
      userIdDaEdicao: 0,
      isLoading: false,
      headers: [
        { text: "ID", value: "id" },
        { text: "Cliente", value: "user.name" },
        { text: "E-mail", value: "user.email" },
        { text: "Plano", value: "plan.name" },
        { text: "Qtd", value: "quantidade" },
        { text: "Valor", value: "valor" },
        { text: "Opções", value: "" },
      ],
      pagination: { sortBy: "id", descending: true }
    };
  },
  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
      self.isLoading = true;
      axios.all([
             axios.get(`carrinhos`),
             axios.get(`planos`),
             axios.get(`usuarios`),
         ]).then(axios.spread((carrinhoRes, planosRes,usuariosRes) => {
            self.carrinho = carrinhoRes.data.data;
             self.planos = planosRes.data;
             self.usuarios = usuariosRes.data;

             for(let item of self.carrinho) {
               item.valor = ((item.quantidade * item.plan.price) + (item.quantidade * item.plan.setup_fee));
             }

             self.isLoading = false;
         })).catch((err) => {
             self.isLoading = false;
             tratamento_requisicao(err, this);
          });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  },
  methods: {
    removerCarrinho(carrinho) {
      let self = this;
      if(confirm('Tem certeza que deseja remover?')){
        self.isLoading = true;
        ajax("delete", "carrinhos/" + carrinho.id)
          .then((response) => {
            self.isLoading = false;
            let indexItemRemovido = self.carrinho.findIndex(
              (x) => x.id == carrinho.id
            );
            self.carrinho.splice(indexItemRemovido, 1);
            alerta("success", "Removido", "Carrinho removido com sucesso!");
          })
          .catch((error) => {
            self.isLoading = false;
            tratamento_requisicao(error, this);
          });
      }
    },
    abreModal(item){
      this.idCarrinhoEdicao = item.id;
      this.planoDaEdicao = item.plan.id;
      this.quantidadeDaEdicao = item.quantidade;
      this.userIdDaEdicao = item.user_id;
      this.$bvModal.show('modalCarrinho')
    },
    editarCarrinho(item){
      var self = this;
      self.isLoading = true;
      let param = {
        user_id: self.userIdDaEdicao,
        quantidade: self.quantidadeDaEdicao,
        plan_id: self.planoDaEdicao
      }
      ajax("put", "/carrinhos/"+ self.idCarrinhoEdicao, param)
        .then(response => {
          self.isLoading = false;
          let indexItemEditado = self.carrinho.findIndex(
            (x) => x.id == self.idCarrinhoEdicao
          );
          self.carrinho[indexItemEditado].quantidade = self.quantidadeDaEdicao;
            alerta(
               "success",
               "Atualizado",
               "Carrinho atualizado com sucesso!"
             );
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    criaCarrinho(){
      var self = this;
      self.isLoading = true;
      ajax("post", "/carrinhos/", self.novoPlano)
        .then(response => {
          self.isLoading = false;
            alerta(
               "success",
               "Criado",
               "Carrinho criado com sucesso!"
             );
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
  },
};
</script>
<style>
    .button-content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
    }
</style>